import React from 'react';
import {Box, IconButton, Typography, withStyles} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import PropTypes from 'prop-types';
import styles from './styles';

const NumberStepper = (props) => {

    const {
        value,
        onChange,
        min = 0,
        classes,
    } = props;
    
    const numericValue = parseFloat(value) || 0;

    return (
        <Box className={classes.stepperInputControl}>
            <IconButton
                size="small"
                color="primary"
                onClick={() => onChange(Math.max(min, numericValue - 1))}
            >
                <RemoveIcon fontSize="small" />
            </IconButton>

            <Typography className={classes.stepperInputValue}>
                {value || 0}
            </Typography>

            <IconButton
                size="small"
                color="primary"
                onClick={() => onChange(numericValue + 1)}
            >
                <AddIcon fontSize="small" />
            </IconButton>
        </Box>
    );
};

NumberStepper.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onChange: PropTypes.func.isRequired,
    min: PropTypes.number,
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(NumberStepper);